import { RESET_STATE } from 'store/global/actions';

import { APPRAISAL_PRODUCT_CRITERIA_ACTION_TYPE } from '../actions';

const initialState = {};

const appraisalProductCriteriaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case APPRAISAL_PRODUCT_CRITERIA_ACTION_TYPE.GET_APPRAISAL_PRODUCT_CRITERIA:
    case APPRAISAL_PRODUCT_CRITERIA_ACTION_TYPE.CREATE_APPRAISAL_PRODUCT_CRITERIA:
    case APPRAISAL_PRODUCT_CRITERIA_ACTION_TYPE.EDIT_APPRAISAL_PRODUCT_CRITERIA:
    case APPRAISAL_PRODUCT_CRITERIA_ACTION_TYPE.DELETE_APPRAISAL_PRODUCT_CRITERIA:
      return payload || state;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default appraisalProductCriteriaReducer;
